import { createAsyncThunk } from '@reduxjs/toolkit';

import { adminBookAPI } from '~/api/admin/book';
import {
  bookModerationActions,
  bookModerationSliceName,
} from '~/atomic/page/book/Book/bookModeration/bookModeration.slice';
import { getBookPageData } from '~/feature/book/book.data';
import { RootState } from '~/store';

export const bookModerationUpdate = createAsyncThunk<
void,
{
  genres: string[],
  tags: string[],
},
{ state: RootState }>(
  `${bookModerationSliceName}/bookModerationUpdate`,
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(bookModerationActions.setIsSavePropertiesLoading(true));
      const { bookPage } = thunkAPI.getState().book;

      const result = await adminBookAPI.updateBookProperties({
        slug: bookPage?.slug,
        canAuthorEditGenres: false,
        ...data,
      });

      if (result?.message) {
        const { message } = await import('~/atomic/atom/message');
        message.success(result.message);
      }

      thunkAPI.dispatch(getBookPageData({ input: { slug: bookPage?.slug } }));
      thunkAPI.dispatch(bookModerationActions.setIsSavePropertiesLoading(false));
    } catch (error) {
      thunkAPI.dispatch(bookModerationActions.setIsSavePropertiesLoading(false));
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  },
);
